export default __webpack_public_path__ + "static/media/redo.17e24b00.png";